import { FileContainer, process } from "am-tax-fe-core";
import { components, paths } from "../generated/generated-api";
import { cachedApiUrl, client } from "../entities/entityApi";
import { uploadFile, uploadForm } from "../uploadUtils";

//#region Dto definition
export type Jurisdiction = components["schemas"]["JurisdictionDto"];
// export type CreateJurisdiction = {
//     name: string;
//     introductionDescription?: string;
//     jurisdictionOverviewBlobPath?: string;
//     abbreviation?: string;
//     active: boolean;
//     regulatoryLanguage: string;
// };
export type CreateOrUpdateJurisdiction = Omit<NonNullable<paths["/api/jurisdictions"]["post"]["requestBody"]>["content"]["multipart/form-data"], "File"> & {
    Id?: string;
};
export type UpdateJurisdiction = CreateOrUpdateJurisdiction & { id: string };

export const getJurisdictionAsync = async (id: string): Promise<Jurisdiction> =>
    process(
        client().GET("/api/jurisdictions/{jurisdictionId}", {
            params: {
                path: {
                    jurisdictionId: id,
                },
            },
        }),
    );

export const getJurisdictionsAsync = async (): Promise<Jurisdiction[]> => process(client().GET("/api/jurisdictions"));

export const createJurisdictionAsync = async (args: CreateOrUpdateJurisdiction, file: FileContainer | undefined) => {
    const jurisdictionData: Record<string, string> = {
        Name: args.Name,
        IntroductionDescription: args.IntroductionDescription || "",
        JurisdictionOverviewBlobPath: args.JurisdictionOverviewBlobPath || "",
        Abbreviation: args.Abbreviation || "",
        Active: args.Active?.toString() || "false",
        RegulatoryLanguage: args.RegulatoryLanguage || "",
    };

    if (file !== undefined) {
        await uploadFile(`${cachedApiUrl}/api/jurisdictions`, file, jurisdictionData, "POST");
    } else {
        await uploadForm(`${cachedApiUrl}/api/jurisdictions`, jurisdictionData);
    }
};

export const updateJurisdictionAsync = async (args: CreateOrUpdateJurisdiction, file: FileContainer | undefined) => {
    const jurisdictionData: Record<string, string> = {
        Name: args.Name,
        IntroductionDescription: args.IntroductionDescription || "",
        JurisdictionOverviewBlobPath: args.JurisdictionOverviewBlobPath || "",
        Abbreviation: args.Abbreviation || "",
        Active: args.Active?.toString() || "false",
        RegulatoryLanguage: args.RegulatoryLanguage || "",
    };

    if (file !== undefined) {
        await uploadFile(`${cachedApiUrl}/api/jurisdictions/${args.Id}`, file, jurisdictionData, "PUT");
    } else {
        await uploadForm(`${cachedApiUrl}/api/jurisdictions/${args.Id}`, jurisdictionData);
    }
};

export const deleteJurisdictionAsync = async (id: string): Promise<Jurisdiction> =>
    process(
        client().DELETE("/api/jurisdictions/{jurisdictionId}", {
            params: {
                path: {
                    jurisdictionId: id,
                },
            },
        }),
    );

export const uploadJurisdictionOverviewFile = async (file: FileContainer, jurisdictionId: string) => {
    return uploadFile(`${cachedApiUrl}/api/jurisdictions/${jurisdictionId}/overview`, file);
};
